/* unplugin-vue-components disabled */import script from "./dawa.vue?vue&type=script&setup=true&lang=js"
export * from "./dawa.vue?vue&type=script&setup=true&lang=js"

import "./dawa.vue?vue&type=style&index=0&id=2fa7fe2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fa7fe2a"]])

export default __exports__